import { useEffect, useState } from "react";

import { verifyOtp, getDependentListData } from "../../../services/liferay/baraemServices";

const BaraemMobileNumberVerify = ({
  setStep,
  setMobileNumberVerificationPupup,
  mobileNum,
  uuid,
  mrn,
  setPatientMobile,
  setDateOfBirth,
  setPatientSex,
  setPatientFirstName,
  setAgeInMonth,
  isDropdownSelected,
  selectedMrnFromDropDown,
  setUuid,
  translationMap
}) => {
  const [otpError, setOtpError] = useState("");
  const [alert, setAlert] = useState(false);
  const [, setIsLoading] = useState(false);

  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: ""
  });
  const [timer, setTimer] = useState(300);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockTimer, setBlockTimer] = useState(0);
  const [, setOtpEntered] = useState(0);

  useEffect(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    if (blockTimer > 0) {
      const interval = setInterval(() => {
        setBlockTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (blockTimer === 0 && isBlocked) {
      setIsBlocked(false);
    }
  }, [blockTimer, isBlocked]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const calculateAge = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);

    const userDob = new Date(year, month - 1, day);
    const today = new Date();

    const yearDiff = today.getFullYear() - userDob.getFullYear();
    const monthDiff = today.getMonth() - userDob.getMonth();

    let totalMonths = yearDiff * 12 + monthDiff;
    if (today.getDate() < userDob.getDate()) {
      totalMonths -= 1;
    }
    return totalMonths;
  };

  const handleOtpChange = (e) => {
    const { id, value } = e.target;
    if (/^\d?$/.test(value)) {
      setOtp((prevOtp) => {
        const updatedOtp = { ...prevOtp, [id.split("-")[1]]: value };
        const allInputsCleared = Object.values(updatedOtp).every(
          (val) => val === ""
        );
        setIsContinueDisabled(allInputsCleared);
        return updatedOtp;
      });
      if (value.length === 1 && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    }
  };

  const handleResendCode = async () => {
    const result = await getDependentListData(
      {
        mrn: isDropdownSelected ? selectedMrnFromDropDown : mrn
      });
    //const info = await createAndSendOtp(mobileNum);
    if (result.status === 200) {

      setAlert(true);
      setIsResendEnabled(false);
      setTimer(300);
      setUuid(result.data.smsid);
    }
  };
  const formatDate = (dob) => {
    if (!dob) return "";
    const year = dob.slice(0, 4);
    const month = dob.slice(4, 6);
    const day = dob.slice(6, 8);
    return `${day}/${month}/${year}`;
  };
  const otpVerification = async () => {
    setOtpError("");
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    try {
      const result = await verifyOtp(fullOtp, uuid, mrn); // Passing full OTP to backend
      // console.log("printing result of verify otp", result);
      setOtp({ first: "", second: "", third: "", fourth: "" });
      // console.log("after verify otp is ",result.data);
      if (result.status === 200) {
        setPatientFirstName(`${result.data?.PatientFirstName?.charAt(0).toUpperCase() + result.data?.PatientFirstName?.slice(1).toLowerCase() || ""} ${result.data.patientLastName ?
        result.data.patientLastName.charAt(0).toUpperCase() + result.data.patientLastName.slice(1).toLowerCase() :
        ""}`
        .trim());

        setPatientMobile(result.data.patientMobile);
        setPatientSex(result.data.patientSex);
        setDateOfBirth(formatDate(result.data.dateofBirth));
        setAgeInMonth(calculateAge(formatDate(result.data.dateofBirth)));
        setMobileNumberVerificationPupup(false);
        setStep(1);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.error === "otpBlocked") {
          setIsBlocked(true);
          setBlockTimer(300);
          setOtpError(
            translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes."
          );
        } else
        if (error.response.data.error === "otpExpired") {
          setOtpError(translationMap?.otpExpiredText ?? "OTP has expired");
        } else {
          setOtpError(translationMap?.invalidOtp ?? "Invalid OTP");
        }
      } else {
        setOtpError(translationMap?.unexpectedErrorText ?? "Unexpected Error occured");
      }
      setOtpEntered((prevOtp) => prevOtp + 1);
      setOtp({ first: "", second: "", third: "", fourth: "" });
    }
  };

  const handleCloseModal = async () => {
    setMobileNumberVerificationPupup(false);
    window.parent.scrollTo(0, 0);
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    await verifyOtp(fullOtp, uuid, mrn);
  };

  return (
    <>
      <div
        className="modal fade Custom_Modal_Box show"
        id="mobilenumberverification"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block", paddingTop: "50px" }}>
        
        <div
          className="modal-dialog CoveragePlan_Dialog2"
          role="document">
          
          <div className="modal-content">
            <div className="modal-header">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">{translationMap?.otpPopUpTitle ?? "Mobile Number Verification"}</h6>
              </div>
            </div>
            {alert &&
            <div className="Alert_Main_Box">
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                  <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setAlert(false)}>
                  
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                    </svg>
                  </button>
                  <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                    </a>
                  </div>
                  <div className="alert_text">
                    <h6>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>{translationMap?.otpResendSuccess ?? "Otp Resend Successfully"}</a>
                    </h6>
                  </div>
                </div>
              </div>
            }
            <div className="modal-body">
              <div className="Manage_Dependent_Modal_Box3">
                <p className="para_txt">
                  {translationMap?.titleForOTP ?? "Please enter the OTP as shared on the mobile number"}{" "}
                  <span style={{ direction: "ltr" }}> {"+971"}{" "}
                  {mobileNum}
                  </span>
                </p>
                <div className="opt_main_box">
                  <p>{translationMap?.verificationText ?? "Verification Code"}</p>
                  <div className="custom_row" style={{ direction: "ltr" }}>
                    {["first", "second", "third", "fourth"].map(
                      (digit, index) =>
                      <input
                        key={digit}
                        id={`otp-${digit}`}
                        type="number"
                        min="0"
                        max="9"
                        className={`input_number_verify ${otpError ? "errorRedAlert" : ""}`
                        }
                        placeholder="0"
                        style={{ MozAppearance: "textfield" }}
                        value={otp[digit]}
                        onChange={handleOtpChange}
                        onKeyDown={(e) => {
                          if (
                          e.key === "Backspace" &&
                          !otp[digit] &&
                          index > 0)
                          {
                            document
                            .querySelectorAll(".input_number_verify")[
                            index - 1].focus();
                          }
                        }} />


                    )}
                  </div>
                  {otpError &&
                  <div className="verifyContent">
                      <p className="codeErrorAlert">{otpError}</p>
                    </div>
                  }
                  <p className="opt_timer_box">
                    {isBlocked ?
                    blockTimer > 0 &&
                    <span className="blockTimer">{`(${Math.floor(
                        blockTimer / 60
                      )}:${String(blockTimer % 60).padStart(
                        2,
                        "0"
                      )})`}</span> :

                    timer > 0 &&
                    <span className="optTimer">{`(${Math.floor(
                        timer / 60
                      )}:${String(timer % 60).padStart(2, "0")})`}</span>
                    }
                  </p>
                </div>
                <h6 className="Gray_Title">
                  {translationMap?.didNotGetText ?? "Didn't Get Code?"}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      if (isResendEnabled) {
                        handleResendCode();
                      }
                    }}
                    style={{
                      color: isResendEnabled ? "#3B4F63" : "#8099B2",
                      cursor: isResendEnabled ? "pointer" : "not-allowed"
                    }}>
                    
                    {" "} {translationMap?.resendCodeText ?? "Click to Resend Code"}
                  </a>
                </h6>
              </div>
            </div>

            <div className="modal-footer modal_footer_btn_box2">
              <button
                onClick={handleCloseModal}
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal">
                
                {translationMap?.back ?? "back"}
              </button>
              <button
                onClick={otpVerification}
                type="button"
                data-dismiss="modal"
                className={`${isContinueDisabled ? "disabled_btn_link" : "btn blue_btn_link"}`
                }
                disabled={isContinueDisabled}
                style={{
                  cursor: isBlocked ? "not-allowed" : "pointer"
                }}>
                
                {" "}
                {translationMap?.continue ?? "Continue"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default BaraemMobileNumberVerify;